import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { BehaviorSubject, catchError, map, Observable, of } from 'rxjs';
import { AuthService } from './auth.service';
import { NgxSpinnerService } from 'ngx-spinner';

export const AUTH_SPINNER = 'authSpinner';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {
  VadlidUer = false;

  /**
   * True from the moment /ValidateToken starts until the guarded route has
   * fully activated. While true, other components' own `spinner.show()`
   * calls (the default/unnamed spinner) are suppressed so they don't flash
   * in right behind the auth overlay during the very first app load.
   */
  private readonly _isValidating = new BehaviorSubject<boolean>(false);
  readonly isValidating$ = this._isValidating.asObservable();

  constructor(
    private authService: AuthService,
    private router: Router,
    private spinner: NgxSpinnerService
  ) {}

  /** Called once the guarded route has activated, to lift the suppression above. */
  settleValidation() {
    this._isValidating.next(false);
  }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.VadlidUer) {
      return true;
    } else {
      this._isValidating.next(true);
      this.spinner.show(AUTH_SPINNER);

      return this.authService.ValidateToken().pipe(
        map((data) => {
          if (data === false) {
            this.VadlidUer = false;
            this.router.navigate(['/login-failed']);
            return false;
          }
          this.spinner.hide(AUTH_SPINNER);
          this.VadlidUer = true;
          return true;
        }),
        catchError(() => {
          this.spinner.hide(AUTH_SPINNER);
          this.VadlidUer = false;
          this.router.navigate(['/login-failed']);
          return of(false);
        })
      );
    }
  }

  async checkValidateToken() {
    this._isValidating.next(true);
    this.spinner.show(AUTH_SPINNER);
    this.authService.ValidateToken().subscribe({
      next: (res: any) => {
        this.spinner.hide(AUTH_SPINNER);
        this.VadlidUer = true;
        return true;
      },
      error: (err: any) => {
        this.spinner.hide(AUTH_SPINNER);
        this.VadlidUer = false;
        this.router.navigate(['/login-failed']);
        return false;
      }
    });
  }
}
